/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAddScalar } from '../../factoriesAny.js';
export var addScalarDependencies = {
  typedDependencies,
  createAddScalar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAddScalar.generated.js
// module id = 41
// module chunks = 2